import { render, staticRenderFns } from "./quxian.vue?vue&type=template&id=12d8d6db&scoped=true&"
import script from "./quxian.vue?vue&type=script&lang=js&"
export * from "./quxian.vue?vue&type=script&lang=js&"
import style0 from "./quxian.vue?vue&type=style&index=0&id=12d8d6db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8d6db",
  null
  
)

export default component.exports